/* NINE theme sections: colour sync, reveal, video autoplay, add to cart */
(function () {
  'use strict';

  function selectBuy(key) {
    var input = document.querySelector('[data-nine-buy] .opt[data-key="' + key + '"] input');
    if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function updateBuy(input) {
    var card = input.closest('[data-nine-buy]');
    if (!card) return;
    card.querySelectorAll('.opt').forEach(function (o) { o.setAttribute('aria-pressed', o.contains(input) ? 'true' : 'false'); });
    card.dataset.color = input.closest('.opt').dataset.key;
    var img = card.querySelector('[data-nine-buy-img]');
    if (img && input.dataset.img) { img.src = input.dataset.img; img.alt = input.dataset.title; }
    var t = card.querySelector('[data-nine-buy-title]'); if (t) t.textContent = input.dataset.title;
    var p = card.querySelector('[data-nine-buy-price]'); if (p) p.textContent = input.dataset.price;
    var btn = card.querySelector('[data-nine-buy-btn]');
    if (btn) {
      var ok = input.dataset.available === 'true';
      btn.disabled = !ok;
      btn.innerHTML = ok ? btn.dataset.label + ' — <span data-nine-buy-btn-price>' + input.dataset.price + '</span>' : btn.dataset.soldout;
    }
  }

  function setHero(btn) {
    var hero = btn.closest('[data-nine-hero]');
    if (!hero) return;
    hero.querySelectorAll('.swatch').forEach(function (s) { s.setAttribute('aria-pressed', s === btn ? 'true' : 'false'); });
    hero.dataset.color = btn.dataset.pick;
    hero.style.setProperty('--hero-bg', btn.dataset.bg);
    hero.style.setProperty('--hero-fg', btn.dataset.fg);
    hero.style.setProperty('--hero-accent', btn.dataset.accent);
    var img = hero.querySelector('[data-nine-hero-img-wrap] img');
    if (img && btn.dataset.img) {
      img.classList.add('swap');
      setTimeout(function () {
        img.removeAttribute('srcset'); img.src = btn.dataset.img; img.alt = 'NINE ' + btn.dataset.name + ' collar with built-in tracker';
        img.onload = function () { img.classList.remove('swap'); };
      }, 200);
    }
    var cta = hero.querySelector('[data-nine-hero-cta]');
    if (cta) cta.textContent = cta.dataset.prefix + ' ' + btn.dataset.name;
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-nine-hero] .swatch');
    if (sw) { setHero(sw); selectBuy(sw.dataset.pick); return; }
    var buy = e.target.closest('[data-buy]');
    if (buy) selectBuy(buy.dataset.buy);
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-nine-buy] .opt input')) updateBuy(e.target);
  });

  /* Add to cart via AJAX so the shopper stays on the page, then go to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-nine-buy-form], #nine-buy-form')) return;
    if (!window.fetch || !window.FormData) return; /* native POST fallback */
    e.preventDefault();
    var btn = form.querySelector('[data-nine-buy-btn]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && res.j.description || 'Could not add to cart');
        document.querySelectorAll('[data-nine-cart-count]').forEach(function (c) { c.textContent = parseInt(c.textContent || '0', 10) + 1; });
        if (btn) btn.textContent = 'Added — going to cart';
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
        alert(err.message);
      });
  });

  /* Reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.nine-root .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Videos: autoplay when visible, respect reduced motion */
  function initVideos() {
    var vids = document.querySelectorAll('.nine-root video');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    vids.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls'); });
    if (reduce) { vids.forEach(function (v) { v.pause(); }); return; }
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init() { initReveal(); initVideos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
